import React, { useEffect, useState, ChangeEvent, useRef } from "react";
import { CheckIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import DetailPagetLayout from "../Layout";
import { Checkbox } from "@headlessui/react";
import toast from "react-hot-toast";
import { formatDateTime, useData } from "data/data-provider";
import { getInvoice } from "api/Invoice/invoice";
import { Booking } from "api/booking/booking";
import { globalJson } from "global/global_json";
import Input from "shared/Input/Input";
import { getBonzahProducts } from "api/bonzah/bonzah";
import { AddCustomer } from "api/customer/customer";
import moment from "moment";
import Badge from "shared/Badge/Badge";
import { getLocationData } from "api/locations/locations";
import LocationBranchInput from "components/HeroSearchForm/LocationBranchInput";
import DropOffBranchLocationInput from "components/HeroSearchForm/DropOffBranchLocationInput";
import RentalCarDatesRangeInput from "components/HeroSearchForm/(car-search-form)/RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "components/HeroSearchForm/(car-search-form)/RentalCarTimesRangeInput";
import { LocationListingModal } from "models/LocationModal";
import NcModal from "shared/NcModal/NcModal";
import useNavigationGuard from "hooks/useNavigationGuard";

export default function ListingCarDetailPage() {
  const navigate = useNavigate();
  const initialBonzahFetched = useRef(false);
  const {
    selectedCar,
    user,
    startDate,
    startHours,
    startMinutes,
    startPeriod,
    endDate,
    endHours,
    endMinutes,
    pickupLocation,
    setInvoice,
    selectedExtras,
    setSelectedExtras,
    bonzahProducts,
    setBookingdetails,
    setBonzahProducts,
    setSelectedBonzahProducts,
    selectedBonzahProducts,
    setSelectedBonzahAddOns,
    selectedBonzahAddOns,
    invoice,
    dropOffLocation,
    searchedPickupLoction,
    searchedDropoffLocation,
    sameDropoffLocation,
    dropoffLocationType,
    endPeriod,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    phone,
    setPhone,
    setDropoffLocation,
    setSameDropoffLocation,
    setDropoffLocationType,
    setPickupLocation,
    setStartDate,
    setEndDate,
    startTime,
    endTime,
  } = useData();

  let [bonzahProductsLoading, setBonzahProductsLoading] = useState(false);
  const isDdropOffdifferent = dropoffLocationType === false;
  const [selectedBonzahType, setSelectedBonzahType] = useState<any>([]);
  const [isDropOffVisible, setIsDropOffVisible] = useState(
    !sameDropoffLocation
  );
  const [loadingLater, setLoadingLater] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [isMoreThan30Days, setIsMoreThan30Days] = useState(false);
  const [isReadMore, setIsReadMore] = useState(true);
  const [selectedBonzah, setSelectedBonzah] = useState();
  const [showImgGallery, setShowImgGallery] = useState(false);
  const [ourLocation, setOurLocation] = useState<LocationListingModal[]>([]);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const pendingNavigationRef = useRef(false);

  const { isDialogOpen, confirmNavigation, cancelNavigation } =
    useNavigationGuard({
      when: isFormDirty,
      onConfirm: () => {
        pendingNavigationRef.current = true;
        setIsFormDirty(false); // Disable guard before navigation
        // reset form-related state when leaving
        setPickupLocation(null);
        setDropoffLocation(null);
        setStartDate(null);
        setEndDate(null);
        setSameDropoffLocation(true);
        setInvoice([]);
        setDropoffLocationType(true);
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");
      },
    });
  console.log("isFormDirty", isFormDirty); // Should be true when guard should be active
  useEffect(() => {
    if (!isFormDirty && pendingNavigationRef.current) {
      pendingNavigationRef.current = false;
      window.history.back();
    }
  }, [isFormDirty]);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!firstName?.trim()) {
      newErrors.firstName = "First Name is required";
    }
    if (!lastName?.trim()) {
      newErrors.lastName = "Last Name is required";
    }
    if (!email?.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email.trim())
    ) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!phone?.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (phone.replace(/\D/g, "").length < 10) {
      newErrors.phone = "Please enter a valid phone number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Clear specific field error
  const clearError = (field: string) => {
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  const fetchBonzahProducts = async (selectedType?: string) => {
    setBonzahProductsLoading(true);

    const payload = {
      company_id: globalJson.prod_company_id,
      selected_type: selectedType,
      fleet: selectedCar?.id,
      pickup_location: pickupLocation?.id,
    };

    const { data, error } = await getBonzahProducts(payload);

    if (data) {
      setBonzahProducts(data);
      const validAddOns = new Set(
        Array.from(selectedBonzahAddOns).filter((addon: any) =>
          data?.addons?.some((item: any) => item.value[0] === addon)
        )
      );
      setSelectedBonzahAddOns(validAddOns);
      if (data?.insurance_options?.length > 0) {
        if (selectedBonzahType?.length === 0) {
          setSelectedBonzahProducts(new Set([data.insurance_options[0].value]));
          setSelectedBonzahType(data.insurance_options[0].value);
        }
      }
      setBonzahProductsLoading(false);
    } else if (error) {
      setBonzahProductsLoading(false);
    }
  };

  useEffect(() => {
    const dirty = Boolean(
      firstName ||
        lastName ||
        email ||
        phone ||
        pickupLocation ||
        dropOffLocation ||
        startDate ||
        endDate
    );
    setIsFormDirty(dirty);
  }, [
    firstName,
    lastName,
    email,
    phone,
    pickupLocation,
    dropOffLocation,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    if (startDate && endDate) {
      const start = moment(startDate);
      const end = moment(endDate);
      const daysDifference = end.diff(start, "days");

      if (daysDifference > 30) {
        setIsMoreThan30Days(true);
        toast("Bonzah Insurance is not available for more than 30 days", {
          style: {
            background: "#fff3cd",
            color: "#856404",
          },
        });
      } else {
        setIsMoreThan30Days(false);
      }
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (!initialBonzahFetched.current) {
      const fetchInitialBonzah = async () => {
        const { data } = await getBonzahProducts({
          company_id:
            process.env.REACT_APP_ENV !== "prod"
              ? globalJson.dev_company_id
              : globalJson.prod_company_id,
          fleet: selectedCar?.id,
        });

        if (data) {
          setBonzahProducts(data);
          if (data.insurance_options?.length > 0) {
            setSelectedBonzahProducts(
              new Set([data.insurance_options[0].value])
            );
            setSelectedBonzahType(data.insurance_options[0].value);
            fetchBonzahProducts(data.insurance_options[0].title.toLowerCase());
            setSelectedBonzah(data.insurance_options[0].title.toLowerCase());
          }
        }
      };
      fetchInitialBonzah();
      initialBonzahFetched.current = true;
    } else {
      if (selectedBonzahType?.length > 0) {
        fetchBonzahProducts(selectedBonzah);
      } else {
        fetchBonzahProducts();
      }
    }
  }, [startDate, endDate, selectedCar, pickupLocation]);

  const toggleAddonSelection = (addonType: string) => {
    setSelectedBonzahAddOns((prevSelected) => {
      const updatedSet = new Set(prevSelected);
      if (updatedSet.has(addonType)) {
        updatedSet.delete(addonType);
      } else {
        updatedSet.add(addonType);
      }
      return updatedSet;
    });
  };

  useEffect(() => {
    const fetchInvoice = async () => {
      if (isDdropOffdifferent && dropOffLocation === null) {
        return;
      } else {
        const selectedAddons = Array.from(selectedBonzahAddOns);
        const addonsValues = selectedAddons
          .map((item) => {
            const addon = bonzahProducts.addons.find(
              (addon: any) => addon.value[0] === item
            );
            return addon ? addon.value : [];
          })
          .flat();

        const payload = {
          customer: user?.id,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off_address: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
        };

        const data = await getInvoice(payload);
        setInvoice(data);
      }
    };
    fetchInvoice();
  }, [
    selectedExtras,
    selectedBonzahProducts,
    selectedBonzahAddOns,
    pickupLocation,
    startMinutes,
    startPeriod,
    startHours,
    endMinutes,
    endPeriod,
    endHours,
    endMinutes,
    endPeriod,
    startDate,
    endDate,
    dropOffLocation,
    sameDropoffLocation,
    searchedPickupLoction,
    searchedDropoffLocation,
  ]);

  useEffect(() => {
    if (selectedCar) {
      callOurLocationAPI();
    }
  }, [selectedCar]);

  const callOurLocationAPI = async () => {
    if (selectedCar) {
      try {
        const data = await getLocationData(selectedCar?.id);
        if (Array.isArray(data)) {
          setOurLocation(data as LocationListingModal[]);
        } else {
          throw new Error("Unable to fetch location data");
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch locations");
        console.error("Location API error:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setSelectedExtras(new Set());
    setSelectedBonzahProducts(new Set());
    setSelectedBonzahAddOns(new Set());
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  const handleBooking = async () => {
    if (!validateForm()) {
      toast.error("Please fill in the details");
      return;
    }
    if (selectedBonzahProducts.size === 0) {
      toast.error("Please select an insurance option before proceeding.");
      return;
    }

    setLoading(true);

    const selectedAddons = Array.from(selectedBonzahAddOns);
    const addonsValues = selectedAddons
      .map((item) => {
        const addon = bonzahProducts.addons.find(
          (addon: any) => addon.value[0] === item
        );
        return addon ? addon.value : [];
      })
      .flat();

    const customerPayload = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_no: phone,
      company: globalJson.prod_company_id,
    };

    try {
      const response = await AddCustomer(customerPayload);
      if (response.data.detail) {
        toast.error(response.data.detail);
        return;
      }
      if (!startDate || !endDate) {
        toast.error("No start date or end date");
        return;
      }
      if (response.data) {
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("refresh_token", response.data.refresh_token);
        localStorage.setItem("user", JSON.stringify(response.data));

        const customerId = response.data.id;

        const payload = {
          customer: customerId,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
        };

        const bookingResponse = await Booking(payload);
        setBookingdetails(bookingResponse);
        if (bookingResponse.error) {
          toast.error(bookingResponse.error);
          return;
        }

        navigate("/checkout");
      }
    } catch (err: any) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleBookingLater = async () => {
    if (isDdropOffdifferent && dropOffLocation === null) {
      toast.error("Please select drop-off location");
      return;
    }
    if (startDate === null && endDate === null) {
      toast.error("Please enter start and end date");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill in the details");
      return;
    }
    if (selectedBonzahProducts.size === 0) {
      toast.error("Please select an insurance option before proceeding.");
      return;
    }

    setLoadingLater(true);

    const selectedAddons = Array.from(selectedBonzahProducts)?.filter((item) =>
      bonzahProducts?.addons.some((addon: any) => addon.value[0] === item)
    );

    const addonsValues: string[] = selectedAddons
      .map((item) => {
        const addon = bonzahProducts?.addons?.find(
          (addon: any) => addon.value[0] === item
        );
        return addon ? addon.value : [];
      })
      .flat();

    const customerPayload = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_no: phone,
      company: globalJson.prod_company_id,
    };

    try {
      const response = await AddCustomer(customerPayload);
      if (response.error) {
        toast.error(response.error);
        return;
      }
      if (!startDate || !endDate) {
        toast.error("No start date or end date");
        return;
      }

      if (response.data) {
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("refresh_token", response.data.refresh_token);
        localStorage.setItem("user", JSON.stringify(response.data));

        const customerId = response.data.id;

        const payload = {
          customer: customerId,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
          pay_later: true,
        };

        const bookingdetail = await Booking(payload);
        if (bookingdetail.error) {
          toast.error(bookingdetail.error);
          setLoadingLater(false);
          return;
        }
        setBookingdetails(bookingdetail);
        toast.success("Your Booking is reserved");
        navigate(`/booking-details?id=${bookingdetail?.unique_identifier}`);
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to complete booking");
      setLoadingLater(false);
    } finally {
      setLoadingLater(false);
    }
  };

  const handleBonzahProductSelection = (productType: any, value: any) => {
    setSelectedBonzahType(value);
    setSelectedBonzahProducts(new Set([value]));
    fetchBonzahProducts(productType);
  };

  const toggleDropOffLocation = () => {
    setIsDropOffVisible((prevState) => !prevState);
  };

  const handleDropOffLocationClick = () => {
    toggleDropOffLocation();
    setDropoffLocationType(false);
    setSameDropoffLocation(false);
  };
  const handlePickupLocationClick = () => {
    toggleDropOffLocation();
    setDropoffLocationType(true);
    setSameDropoffLocation(true);
    setDropoffLocation(null);
  };

  const handleOpenModalImageGallery = () => {
    if (selectedCar?.fleet_photos?.length === 0) {
      toast("No Images available for this fleet", {
        style: {
          background: "#fff3cd",
          color: "#856404",
        },
      });
    } else {
      setShowImgGallery(true);
    }
  };

  const vehicleDescriptionSection = () => {
    return (
      <div className="listingSection__wrap rounded-md">
        <h2 className="text-2xl font-semibold">Vehicle Description</h2>
        {selectedCar?.description && (
          <div className="break-words overflow-hidden">
            <p className="whitespace-pre-line break-words">
              {isReadMore
                ? selectedCar?.description?.slice(0, 230)
                : selectedCar?.description}
              {(selectedCar?.description?.length ?? 0) > 230 && (
                <span
                  className="text-primary-100 cursor-pointer"
                  onClick={toggleReadMore}
                >
                  {isReadMore ? " ...read more" : " ...show less"}
                </span>
              )}
            </p>
          </div>
        )}
        {selectedCar?.features && selectedCar.features.length > 0 && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-6 gap-x-10 text-sm">
            {selectedCar?.features?.map((item, index) => (
              <div key={index} className="flex items-center space-x-4 ">
                <span>{item.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderUserSection = () => {
    return (
      <div className="border-[#E5E7EB] flex flex-col rounded-md border-b sm:border-t sm:border-l sm:border-r sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8 !space-y-6">
        {" "}
        <h2 className="text-xl text-[#111827] font-bold">Trip Details</h2>
        <form className="flex flex-col border-neutral-200 dark:border-neutral-700 rounded-md ">
          <div className={`${isDdropOffdifferent ? " " : "w-full my-2"}`}>
            <LocationBranchInput
              ourLocation={ourLocation}
              placeHolder="Pick Up Location"
              className="w-full bg-white rounded-md border"
              sameDropOffLocation={dropoffLocationType === false}
            />
          </div>
          {isDropOffVisible && (
            <div className="my-2">
              <DropOffBranchLocationInput
                ourLocation={ourLocation}
                placeHolder="Dropoff Location"
                className="w-full bg-white rounded-md border"
                divHideVerticalLineClass="-inset-x-0.5"
              />

              <p
                className="text-xs text-primary-200 cursor-pointer mt-2 font-semibold"
                onClick={handlePickupLocationClick}
              >
                - Same Dropoff Location
              </p>
            </div>
          )}
          {!isDropOffVisible && (
            <p
              className="text-xs text-primary-200 cursor-pointer mb-2 font-semibold"
              onClick={handleDropOffLocationClick}
            >
              + Different Dropoff Location
            </p>
          )}

          {pickupLocation && (
            <RentalCarDatesRangeInput
              isMiddle={true}
              className="w-full bg-white rounded-md my-2 border"
              selectedCar={selectedCar}
              searchBar={false}
            />
          )}

          {startDate && endDate && (
            <RentalCarTimesRangeInput
              dropOffLocationType={dropoffLocationType}
              className="w-full bg-white rounded-md border my-2"
              searchBar={true}
            />
          )}
        </form>
        <h2 className="text-xl text-[#111827] font-bold">Renter Details</h2>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="border p-2 rounded-md">
              <span className="my-2 text-sm">First Name</span>
              <Input
                placeholder=""
                value={firstName}
                className="border-none !p-0 focus:outline-none focus:ring-0"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setFirstName(e.target.value);
                  if (e.target.value) clearError("firstName"); // Clear error if input is valid
                }}
              />
            </div>
            {errors.firstName && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.firstName}
              </span>
            )}
          </div>
          <div>
            <div className="border p-2 rounded-md">
              <span className="my-2 text-sm">Last Name</span>
              <Input
                placeholder=""
                value={lastName}
                className="border-none !p-0 focus:outline-none focus:ring-0"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setLastName(e.target.value);
                  if (e.target.value) clearError("lastName");
                }}
              />
            </div>
            {errors.lastName && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.lastName}
              </span>
            )}
          </div>
          <div>
            <div className="border p-2 rounded-md">
              <span className="my-2 text-sm">Email</span>
              <Input
                placeholder=""
                type="email"
                className="border-none !p-0 focus:outline-none focus:ring-0"
                value={email}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setEmail(e.target.value);
                  if (
                    /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
                      e.target.value
                    )
                  ) {
                    clearError("email");
                  }
                }}
              />
            </div>
            {errors.email && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.email}
              </span>
            )}
          </div>
          <div>
            <div className="border p-2 rounded-md">
              <span className="my-2 text-sm">Phone</span>
              <PhoneInput
                country={"us"}
                value={phone}
                onChange={(phone) => {
                  setPhone(phone);
                  if (phone.length >= 10) clearError("phone");
                }}
                inputProps={{
                  name: "phone",
                  required: true,
                  autoFocus: false,
                }}
                inputStyle={{
                  border: "none",
                  width: "100%",
                  minHeight: "44px",
                  boxShadow: "none",
                }}
                buttonStyle={{
                  background: "transparent",
                  border: "none",
                }}
              />
            </div>
            {errors.phone && (
              <span className="text-red-500 text-xs font-semibold ">
                {errors.phone}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const handleExtraChange = (extraId: any, checked: any) => {
    setSelectedExtras((prevSelectedExtras) => {
      const updatedExtras = new Set(prevSelectedExtras);
      if (checked) {
        updatedExtras.add(extraId);
      } else {
        updatedExtras.delete(extraId);
      }
      return updatedExtras;
    });
  };

  useEffect(() => {
    if (selectedCar?.extras) {
      const requiredExtras = selectedCar.extras
        .filter((extra: any) => extra.is_required)
        .map((extra: any) => extra.id);
      setSelectedExtras((prev) => {
        const updated = new Set(prev);
        requiredExtras.forEach((id) => updated.add(id));
        return updated;
      });
    }
  }, [selectedCar]);

  const renderExtrasSection = () => {
    return (
      <div className="listingSection__wrap rounded-md">
        <h2 className="text-2xl font-bold text-[#111827] dark:text-white">
          Extras
        </h2>
        {!bonzahProductsLoading &&
          !isMoreThan30Days &&
          bonzahProducts?.addons?.map((addon: any) => (
            <div
              key={addon.title}
              className="flex flex-col justify-between items-start border rounded-3xl p-4 max-w-full"
            >
              <div className="flex items-start">
                <Checkbox
                  checked={selectedBonzahAddOns.has(addon.value[0])}
                  onChange={() => toggleAddonSelection(addon.value[0])}
                  className="group size-7 rounded-md p-1 ring-1 ring-primary-200 data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20 ring-inset  mr-4"
                >
                  <CheckIcon
                    className={`size-5 stroke-primary-200 ${
                      selectedBonzahAddOns.has(addon.value[0])
                        ? "visible"
                        : "invisible"
                    }`}
                  />
                </Checkbox>

                <div>
                  <div className="flex items-center mb-2">
                    <h2 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white">
                      {addon.title}
                    </h2>
                    <button
                      className="ml-2 text-gray-500 dark:text-gray-400"
                      onClick={() => window.open(addon.pdf, "_blank")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="none"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill="#1B2430"
                          d="M9.997 18.958c-4.941 0-8.958-4.016-8.958-8.958s4.017-8.958 8.958-8.958c4.942 0 8.959 4.016 8.959 8.958s-4.017 8.958-8.959 8.958Zm0-16.666C5.747 2.292 2.29 5.75 2.29 10s3.458 7.708 7.708 7.708S17.706 14.25 17.706 10s-3.459-7.708-7.709-7.708Z"
                        />
                        <path
                          fill="#1B2430"
                          d="M10 11.458a.63.63 0 0 1-.625-.625V6.667A.63.63 0 0 1 10 6.042a.63.63 0 0 1 .625.625v4.166a.63.63 0 0 1-.625.625Zm-.003 2.709a.829.829 0 0 1-.316-.067.963.963 0 0 1-.275-.175.86.86 0 0 1-.175-.275.83.83 0 0 1-.067-.317.83.83 0 0 1 .067-.316c.041-.1.1-.192.175-.275a.96.96 0 0 1 .275-.175.833.833 0 0 1 .633 0c.1.041.192.1.275.175a.963.963 0 0 1 .175.275.83.83 0 0 1 .067.316.83.83 0 0 1-.067.317.86.86 0 0 1-.175.275.964.964 0 0 1-.275.175.83.83 0 0 1-.317.067Z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-4 md:mt-0 w-full">
                <p className="lg:text-2xl text-lg font-bold text-gray-900 dark:text-gray-100 flex justify-end items-center">
                  ${addon?.price?.toFixed(2)}
                  <span className="text-gray-400 lg:text-lg">/day</span>
                </p>
              </div>
            </div>
          ))}
        {selectedCar?.extras.map((extra) => (
          <div
            key={extra.id}
            className="w-full rounded-3xl border border-[#E5E7EB] flex justify-between items-center p-5"
          >
            <div className="flex justify-start flex-1 min-w-0">
              <Checkbox
                checked={selectedExtras?.has(extra.id)}
                onChange={(checked) => {
                  if (!extra.is_required) {
                    handleExtraChange(extra.id, checked);
                  }
                }}
                className="group size-7 rounded-md  p-1 ring-1 ring-primary-200 ring-inset data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20  mr-4"
                disabled={extra.is_required}
              >
                <CheckIcon
                  className={`size-5 stroke-primary-200 ${
                    selectedExtras.has(extra.id) ? "visible" : "invisible"
                  }`}
                />
              </Checkbox>
              <div className="min-w-0">
                <div className="text-gray-900 dark:text-gray-200 lg:text-lg sm:text-l font-bold flex space-x-2 flex-wrap break-words">
                  <span className="truncate block max-w-xs">{extra.name}</span>
                </div>
                <div className="text-gray-400 dark:text-neutral-400 lg:text-lg sm:text-md font-medium ">
                  {renderDescriptionWithLink(extra.description)}
                </div>
              </div>
            </div>

            <div className="mt-4 md:mt-0 flex-shrink-0 flex flex-col items-end">
              <div className="mb-2 flex space-x-2">
                {extra.is_required && <Badge color="blue" name="Required" />}
                {extra.is_recommended === true && (
                  <Badge color="blue" name="Recommended" />
                )}
              </div>
              <p className="lg:text-2xl text-lg font-bold text-gray-900 dark:text-gray-100 flex justify-end items-center whitespace-nowrap">
                ${extra?.amount}
                <span className="text-gray-400 lg:text-lg">
                  {" "}
                  /{extra?.nature === "per_day" ? "day" : "trip"}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderDescriptionWithLink = (description: string) => {
    // Regular expression to detect URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Split the description into parts: text and URLs
    const parts = description.split(urlRegex);

    return parts.map((part, index) => {
      // If the part matches the URL pattern, render it as a clickable link
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            {part}
          </a>
        );
      }
      // Otherwise, render the text normally
      return <span key={index}>{part}</span>;
    });
  };

  const renderBonzahSection = () => {
    const validOptions =
      bonzahProducts?.insurance_options?.filter(
        (product: any) => !(product.insurance_by_bonzah === true)
      ) || [];
    if (validOptions.length === 0) return null;
    return (
      <div className="listingSection__wrap rounded-md">
        <h2 className="text-2xl text-[#111827] dark:text-white font-bold">
          Trip Insurance
        </h2>
        {bonzahProducts?.insurance_options
          ?.filter(
            (product: any) =>
              !(isMoreThan30Days && product.insurance_by_bonzah === true)
          )
          .map((product: any, index: any) => (
            <div
              key={product.title}
              className="flex flex-col justify-between items-start border rounded-lg p-4 max-w-full overflow-hidden"
              style={{ wordBreak: "break-word" }}
            >
              <div className="flex items-start w-full">
                <Checkbox
                  checked={
                    JSON.stringify(selectedBonzahType) ===
                    JSON.stringify(product?.value)
                  }
                  onChange={() =>
                    handleBonzahProductSelection(
                      product.title.toLowerCase(),
                      product?.value
                    )
                  }
                  className="group size-7 rounded-md p-1 ring-1 ring-primary-200 ring-inset data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20  mr-4"
                >
                  <CheckIcon
                    className={`size-5 stroke-primary-200 ${
                      JSON.stringify(selectedBonzahType) ===
                      JSON.stringify(product?.value)
                        ? "visible"
                        : "invisible"
                    }`}
                  />
                </Checkbox>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center mb-2">
                    <h2 className="text-lg md:text-xl font-bold text-gray-900 dark:text-gray-100 truncate">
                      {product.title}
                    </h2>
                    {product?.pdf !== "" && (
                      <button
                        className="ml-2 text-gray-500 dark:text-gray-400"
                        onClick={() => window.open(product.pdf, "_blank")}
                        type="button"
                        tabIndex={-1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#1B2430"
                            d="M9.997 18.958c-4.941 0-8.958-4.016-8.958-8.958s4.017-8.958 8.958-8.958c4.942 0 8.959 4.016 8.959 8.958s-4.017 8.958-8.959 8.958Zm0-16.666C5.747 2.292 2.29 5.75 2.29 10s3.458 7.708 7.708 7.708S17.706 14.25 17.706 10s-3.459-7.708-7.709-7.708Z"
                          />
                          <path
                            fill="#1B2430"
                            d="M10 11.458a.63.63 0 0 1-.625-.625V6.667A.63.63 0 0 1 10 6.042a.63.63 0 0 1 .625.625v4.166a.63.63 0 0 1-.625.625Zm-.003 2.709a.829.829 0 0 1-.316-.067.963.963 0 0 1-.275-.175.86.86 0 0 1-.175-.275.83.83 0 0 1-.067-.317.83.83 0 0 1 .067-.316c.041-.1.1-.192.175-.275a.96.96 0 0 1 .275-.175.833.833 0 0 1 .633 0c.1.041.192.1.275.175a.963.963 0 0 1 .175.275.83.83 0 0 1 .067.316.83.83 0 0 1-.067.317.86.86 0 0 1-.175.275.964.964 0 0 1-.275.175.83.83 0 0 1-.317.067Z"
                          />
                        </svg>
                      </button>
                    )}
                  </div>

                  {product?.options &&
                    Object.entries(product.options).map(([key, values]) => (
                      <div key={key} className="mt-2">
                        {!product.canopy && product.insurance_by_bonzah && (
                          <h3 className="font-semibold text-gray-700 dark:text-gray-300 uppercase truncate">
                            {key}
                          </h3>
                        )}
                        <p className="text-sm text-gray-600 dark:text-gray-400">
                          {(Array.isArray(values) ? values : [values]).map(
                            (detail, index) => {
                              // If detail is HTML from Quill editor, render as HTML but make links clickable
                              if (
                                typeof detail === "string" &&
                                detail.trim().startsWith("<")
                              ) {
                                // Replace URLs in HTML with anchor tags if not already wrapped
                                const urlRegex = /(https?:\/\/[^\s<>"']+)/g;
                                let html = detail.replace(urlRegex, (url) => {
                                  // If already inside an anchor tag, skip
                                  if (detail.includes(`<a href="${url}`))
                                    return url;
                                  return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:underline">${url}</a>`;
                                });
                                return (
                                  <span
                                    key={index}
                                    className={
                                      product.canopy
                                        ? "text-red-500 font-semibold"
                                        : ""
                                    }
                                    style={{ wordBreak: "break-word" }}
                                    dangerouslySetInnerHTML={{ __html: html }}
                                  />
                                );
                              }
                              // If detail contains a URL, make it clickable
                              const urlRegex = /(https?:\/\/[^\s]+)/g;
                              if (
                                typeof detail === "string" &&
                                urlRegex.test(detail)
                              ) {
                                const parts = detail.split(urlRegex);
                                return (
                                  <span
                                    key={index}
                                    className={
                                      product.canopy
                                        ? "text-red-500 font-semibold"
                                        : ""
                                    }
                                    style={{ wordBreak: "break-word" }}
                                  >
                                    {parts.map((part, i) =>
                                      urlRegex.test(part) ? (
                                        <a
                                          key={i}
                                          href={part}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="text-blue-500 hover:underline"
                                          style={{ wordBreak: "break-word" }}
                                        >
                                          {part}
                                        </a>
                                      ) : (
                                        <React.Fragment key={i}>
                                          {part}
                                        </React.Fragment>
                                      )
                                    )}
                                    <br />
                                  </span>
                                );
                              }
                              // Otherwise, render as plain text
                              return (
                                <span
                                  key={index}
                                  className={
                                    product.canopy
                                      ? "text-red-500 font-semibold"
                                      : ""
                                  }
                                  style={{ wordBreak: "break-word" }}
                                >
                                  {detail}
                                  <br />
                                </span>
                              );
                            }
                          )}
                        </p>
                      </div>
                    ))}
                </div>
              </div>

              <div className="mt-4 md:mt-0 w-full flex justify-end items-center">
                <p className="text-2xl font-bold text-gray-900 dark:text-gray-100 truncate">
                  ${product.price.toFixed(2)}
                  <span className="text-gray-400 lg:text-lg">
                    /
                    {product.nature === "per_trip"
                      ? "trip"
                      : product.nature === "per_day"
                      ? "day"
                      : "24 hours"}
                  </span>
                </p>
              </div>
            </div>
          ))}
      </div>
    );
  };

  const renderSidebarPrice = () => {
    return (
      <div className="listingSectionSidebar__wrap shadow-xl rounded-md">
        <div className="w-full max-w-lg  mx-auto bg-white dark:bg-gray-800">
          <h2 className="text-xl font-medium text-gray-900 dark:text-gray-100">
            Rental Bill
          </h2>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            Prices may change depending on the length of the rental and the
            price of your rental car.
          </p>

          {pickupLocation !== null && invoice?.car_total !== undefined && (
            <>
              <div className="mt-4">
                <div className="pb-4">
                  <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                    Trip Price
                  </span>
                </div>
              </div>

              <div className="flex justify-between truncate">
                <span className="truncate flex-1">{selectedCar?.name}</span>
                <span className="flex flex-col items-end ">
                  <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                    ${Number(invoice?.car_total).toFixed(2)}
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    ${invoice?.avg_car_price_per_day + " x "}
                    {invoice?.trip_days + "-Days  "}
                  </span>
                </span>
              </div>

              {invoice?.breakdown?.locations?.length > 0 &&
                invoice?.location_total !== undefined && (
                  <div className="mt-4">
                    <div className="pb-4">
                      <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                        Location Total
                      </span>
                    </div>
                    {invoice?.breakdown?.locations?.map(
                      (location: any, index: any) => (
                        <div key={index} className="flex justify-between ">
                          <span className="truncate flex-1">
                            {location?.name}
                          </span>
                          <div className="flex flex-col items-end">
                            <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                              ${Number(location?.total).toFixed(2)}
                            </span>
                            <span className="text-sm text-gray-500 dark:text-gray-400">
                              {location?.rate}
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}

              {invoice?.breakdown?.insurance?.length > 0 &&
                invoice?.insurance_total !== undefined && (
                  <div className="mt-4">
                    <div className="pb-4">
                      <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                        Insurance Total
                      </span>
                    </div>
                    {invoice?.breakdown?.insurance?.map(
                      (insurance: any, index: any) => (
                        <div key={index} className="flex justify-between">
                          <span className="truncate flex-1">
                            {insurance?.name}
                          </span>
                          <div className="flex flex-col items-end">
                            <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                              ${Number(insurance?.total).toFixed(2)}
                            </span>
                            <span className="text-sm text-gray-500 dark:text-gray-400">
                              {insurance?.rate}
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}

              {invoice?.breakdown?.extras?.length > 0 &&
                invoice?.extras_total !== undefined && (
                  <div className="mt-4">
                    <div className="pb-4">
                      <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                        Trip Extras
                      </span>
                    </div>
                    {invoice?.breakdown?.extras?.map(
                      (extra: any, index: any) => (
                        <div key={index} className="flex justify-between ">
                          <span className="truncate flex-1">{extra?.name}</span>
                          <div className="flex flex-col items-end">
                            <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                              ${Number(extra?.total).toFixed(2)}
                            </span>
                            <span className="text-sm text-gray-500 dark:text-gray-400">
                              ${extra?.rate}
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}

              {invoice?.booking_fee !== "0.00" &&
                invoice?.booking_fee !== undefined && (
                  <div className="mt-4">
                    <div className="pb-4">
                      <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                        Booking Fee
                      </span>
                    </div>
                    {invoice?.breakdown?.booking_fee?.map(
                      (bookingFee: any, index: any) => (
                        <div key={index} className="flex justify-between ">
                          <span className="truncate flex-1">
                            {" "}
                            {bookingFee?.description
                              ? bookingFee?.description
                              : bookingFee?.name}
                          </span>
                          <div className="flex flex-col items-end">
                            <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                              ${Number(bookingFee?.total).toFixed(2)}
                            </span>
                            <span>
                              {bookingFee?.rate.includes("%")
                                ? bookingFee?.rate
                                : `$${bookingFee?.rate}`}
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}

              {invoice?.breakdown?.taxes?.length > 0 &&
                invoice?.tax !== undefined && (
                  <div className="mt-4">
                    <div className="pb-4">
                      <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                        Tax & Fee
                      </span>
                    </div>
                    {invoice?.breakdown?.taxes?.map(
                      (taxes: any, index: any) => (
                        <div key={index} className="flex justify-between ">
                          <span>
                            {" "}
                            {taxes?.description
                              ? taxes?.description
                              : taxes?.name}
                          </span>
                          <div className="flex flex-col items-end">
                            <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                              ${Number(taxes?.total).toFixed(2)}
                            </span>
                            <span>
                              {taxes?.rate.includes("%")
                                ? taxes?.rate
                                : `$${taxes?.rate}`}
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}

              {invoice?.discount !== "0.00" &&
                invoice?.discount !== undefined && (
                  <div className="mt-4">
                    <div className="flex justify-between ">
                      <span className="text-lg font-normal text-gray-700 dark:text-gray-300">
                        Discount
                      </span>
                      <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                        - ${Number(invoice.discount).toFixed(2)}
                      </span>
                    </div>
                  </div>
                )}

              <div className="mt-8 border-t border-gray-200 dark:border-gray-700 pt-4">
                {invoice.total_price_without_security !== "0.00" &&
                  invoice.total_price_without_security !== undefined && (
                    <div className="flex justify-between ">
                      <div>
                        <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                          Total Rental Price
                        </span>
                        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                          Overall price rental
                        </p>
                      </div>
                      <div>
                        <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                          $
                          {Number(invoice.total_price_without_security).toFixed(
                            2
                          )}
                        </span>
                      </div>
                    </div>
                  )}
              </div>

              {invoice.security_deposit_total !== "0.00" &&
                invoice.security_deposit_total !== undefined && (
                  <div className="mt-4">
                    <div className="flex justify-between ">
                      <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                        Refundable Deposit
                      </span>
                      <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                        ${Number(invoice.security_deposit_total).toFixed(2)}
                      </span>
                    </div>
                  </div>
                )}
            </>
          )}
        </div>

        <ButtonPrimary
          className="block rounded-md"
          onClick={() => {
            handleBooking();
          }}
        >
          {loading ? (
            <div className="flex justify-center items-center col-span-full">
              <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
            </div>
          ) : (
            "Pay & Book"
          )}
        </ButtonPrimary>
        {selectedCar?.pay_later && (
          <ButtonPrimary
            className="block rounded-md mt-4"
            disabled={loadingLater}
            onClick={() => {
              handleBookingLater();
            }}
          >
            {loadingLater ? (
              <div className="flex justify-center items-center col-span-full">
                <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
              </div>
            ) : (
              "Pay Later"
            )}
          </ButtonPrimary>
        )}
      </div>
    );
  };
  return (
    <DetailPagetLayout
      showImgGallery={showImgGallery}
      setShowImgGallery={setShowImgGallery}
    >
      <>
        <div className={` nc-ListingCarDetailPage mt-4`}>
          <header className="rounded-md sm:rounded-md">
            <div className="relative grid grid-cols-1 md:grid-cols-4  gap-1 sm:gap-2 min-h-96 ">
              <div
                className="col-span-2 row-span-2 relative rounded-md sm:rounded-md overflow-hidden cursor-pointer"
                onClick={handleOpenModalImageGallery}
              >
                <img
                  src={
                    (selectedCar?.fleet_photos?.length ?? 0) > 0
                      ? selectedCar?.fleet_photos[0].photo_url.includes("http")
                        ? selectedCar?.fleet_photos[0].photo_url
                        : `https://fleet-management-images-upload-be.s3.amazonaws.com/${selectedCar?.fleet_photos[0].photo_url}`
                      : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                  }
                  alt="0"
                  className="absolute inset-0 object-cover rounded-md sm:rounded-md w-full h-full"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                />
                <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
              </div>

              {/*  */}
              <div
                className="col-span-1 row-span-2 relative rounded-md sm:rounded-md overflow-hidden cursor-pointer"
                onClick={handleOpenModalImageGallery}
              >
                <img
                  className="absolute inset-0 object-cover rounded-md sm:rounded-md w-full h-full"
                  src={
                    (selectedCar?.fleet_photos?.length ?? 0) > 1
                      ? selectedCar?.fleet_photos[1].photo_url.includes("http")
                        ? selectedCar?.fleet_photos[1].photo_url
                        : `https://fleet-management-images-upload-be.s3.amazonaws.com/${selectedCar?.fleet_photos[1].photo_url}`
                      : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                  }
                  alt="1"
                  sizes="400px"
                />
                <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
              </div>

              {/*  */}
              {selectedCar?.fleet_photos
                .filter((_, i) => i >= 2 && i < 4)
                .map((item, index) => (
                  <div
                    key={index}
                    className={`relative rounded-md sm:rounded-md overflow-hidden ${
                      index >= 2 ? "block" : ""
                    }`}
                  >
                    <div className="aspect-w-4 aspect-h-3">
                      <img
                        className="absolute inset-0 object-cover w-full h-full rounded-md sm:rounded-md "
                        src={
                          item.photo_url.includes("http")
                            ? item.photo_url
                            : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                        }
                        alt="photos"
                        sizes="400px"
                      />
                    </div>
                    <div
                      className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                      onClick={handleOpenModalImageGallery}
                    />
                  </div>
                ))}

              {(selectedCar?.fleet_photos?.length ?? 0) > 0 && (
                <div
                  className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
                  onClick={handleOpenModalImageGallery}
                >
                  <Squares2X2Icon className="h-5 w-5" />
                  <span className="ml-2 text-neutral-800 text-sm font-medium">
                    Show all photos
                  </span>
                </div>
              )}
            </div>
          </header>
          <NcModal
            isOpenProp={isDialogOpen}
            onCloseModal={cancelNavigation}
            modalTitle={"Leave this page?"}
            contentExtraClass="max-w-md"
            renderContent={() => (
              <div>
                <p className="text-sm text-neutral-600 dark:text-neutral-300">
                  Your entered information will be lost. Are you sure you want
                  to go back?
                </p>
                <div className="mt-6 flex justify-end space-x-3">
                  <button
                    type="button"
                    className="px-4 py-2 rounded-md border border-neutral-300 dark:border-neutral-700"
                    onClick={cancelNavigation}
                  >
                    Stay
                  </button>
                  <button
                    type="button"
                    className="px-4 py-2 rounded-md bg-red-600 text-white"
                    onClick={confirmNavigation}
                  >
                    Leave
                  </button>
                </div>
              </div>
            )}
          />
          <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
            <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:pr-10 lg:space-y-10">
              {(selectedCar?.description ||
                (selectedCar?.features && selectedCar.features.length > 0)) &&
                vehicleDescriptionSection()}
              {renderUserSection()}
              {renderBonzahSection()}
              {((selectedCar?.extras ?? []).length > 0 ||
                (bonzahProducts?.addons ?? []).length > 0) &&
                renderExtrasSection()}
            </div>

            <div className="block flex-grow mt-0 lg:mt-0">
              <div className="block sticky top-28">{renderSidebarPrice()}</div>
            </div>
          </main>
        </div>
      </>
    </DetailPagetLayout>
  );
}
